import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { Brand } from '../../models/brand.model';
import { BrandLogo } from '../../models/brand-logo.model';

import { BrandProvider } from "../../providers/brand/brand";

import { API_URL } from '../../providers/api-url';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-brand',
  templateUrl: 'brand.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class BrandPage {

  brand: Brand;
  err: string;
  loading: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, private iab: InAppBrowser, public brandProvider: BrandProvider) {}

  getBrand() {
    this.loading = true;
    this.brandProvider.getSelectedBrand()
      .subscribe(
        brand => this.brand = brand,
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  isImage(filename: string) {
    let re = /(?:\.([^.]+))?$/;
    if (['jpg', 'jpeg', 'png', 'gif'].indexOf(re.exec(filename)[1]) > -1) {
      return true;
    } else {
      return false;
    }
  }

  getIconFromExt(filename: string) {
    let re = /(?:\.([^.]+))?$/;
    let ext = re.exec(filename)[1];
    return `assets/images/icon-${ext}.png`;
  }

  toInt(s: string) {
    return parseInt(s);
  }

  download(logo: BrandLogo) {
    this.iab.create(`${API_URL}/brand-logos/download/${logo.id}`, '_system', 'location=no');
  }

  downloadGuidelines(guidelinesUrl: string) {
    this.iab.create(guidelinesUrl, '_system', 'location=no');
  }

  ionViewDidLoad() {
    this.getBrand();
  }

}



// WEBPACK FOOTER //
// ./src/pages/brand/brand.ts